import { faAirConditioner, faCar, faElevator, faRampLoading } from '@fortawesome/pro-light-svg-icons';

import { Icon } from '@/components/ui/icon.component';

type PartnerStructureProps = {
  structure: {
    airConditioning: boolean;
    elevator: boolean;
    parking: boolean;
    specialAccess: boolean;
  };
  className?: string;
};

const structureItems = {
  airConditioning: {
    icon: faAirConditioner,
    text: 'Ar-condicionado',
  },
  elevator: {
    icon: faElevator,
    text: 'Elevador',
  },
  parking: {
    icon: faCar,
    text: 'Estacionamento',
  },
  specialAccess: {
    icon: faRampLoading,
    text: 'Rampa',
  },
};

export default function PartnerStructure({ structure }: PartnerStructureProps) {
  return (
    <section className="flex flex-col gap-3">
      {Object.keys(structureItems).map((key, index) => {
        const item = structureItems[key as keyof typeof structureItems];
        if (structure[key as keyof typeof structure]) {
          return (
            <div key={index} className="flex flex-row gap-2 items-center">
              <Icon icon={item.icon} className="text-gray-500 text-2xl h-6 w-6" />
              <p className="text-gray-700 font-normal leading-6">{item.text}</p>
            </div>
          );
        }
        return null;
      })}
    </section>
  );
}
